function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 537",
    style: {
      stroke: "#f5f5f5",
      strokeWidth: 5
    },
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.094s-3.185 4.554-3.185 6.333a3.185 3.185 0 1 0 6.37 0c0-1.779-3.185-6.333-3.185-6.333m2.236 6.106a.819.819 0 1 1-.818-.828.823.823 0 0 1 .818.828m.394-7.493a.7.7 0 0 1-.495-.2 3.091 3.091 0 0 0-4.27 0 .7.7 0 0 1-.99-.99 4.418 4.418 0 0 1 6.25 0 .7.7 0 0 1-.495 1.195M16.6 7.74a.7.7 0 0 1-.495-.2 5.815 5.815 0 0 0-8.215 0 .7.7 0 1 1-.99-.99 7.219 7.219 0 0 1 10.2 0 .7.7 0 0 1-.5 1.195m1.973-1.973a.7.7 0 0 1-.5-.2 8.605 8.605 0 0 0-12.16 0 .7.7 0 0 1-.991-.99 10.01 10.01 0 0 1 14.141 0 .7.7 0 0 1-.495 1.194",
    style: {
      fill: "#fff"
    },
    transform: "translate(5 5)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.c62b76e42ff1673ac6e7c449e64d1dd2.svg";
export { ForwardRef as ReactComponent };